import { render } from "./OpportVSRisk.vue?vue&type=template&id=5fe94cf2&scoped=true"
import script from "./OpportVSRisk.vue?vue&type=script&lang=js"
export * from "./OpportVSRisk.vue?vue&type=script&lang=js"

import "./OpportVSRisk.vue?vue&type=style&index=0&id=5fe94cf2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fe94cf2"]])

export default __exports__